import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {Category, Intercalaire, SubCategory, Word} from '../../_models';
import {FormControl, FormGroup} from '@angular/forms';
import {CategoryService} from '../../_services';
import {WordService} from '../../_services/word.service';
import {first} from 'rxjs/operators';
import {config} from '../../../assets/config';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-show-word',
  templateUrl: './show-word.component.html',
  styleUrls: ['./show-word.component.scss']
})
export class ShowWordComponent {

    @Output() wordEdit: EventEmitter<Word> = new EventEmitter<Word>();

    items = [
        { title: 'Slide 1' },
        { title: 'Slide 2' },
        { title: 'Slide 3' },
    ];
    files = [];
    refreshCarousel = false;
    apiUrl = config.apiUrl;

  constructor(private wordService: WordService, private sanitizer: DomSanitizer) { }

    @Input() intercalaire: Intercalaire;
    @Input() category: Category;
    @Input() subCategory: SubCategory;
    @Input() word: Word;
    @Input() visible: boolean;

    breadcrumb = '';
    playing = false;

    ngOnChanges(changes: SimpleChanges) {

        if (this.word) {
            this.files = [];

            const file = {type: 'image', url: (this.word as any).fileName};
            this.files.push(file);

            this.wordService.getAdditionalFiles(this.word.id).pipe(first()).subscribe(files => {
                (files as any[]).map(file => {
                    file.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(file.url);
                    this.files.push(file);

                    this.refreshCarousel = !this.refreshCarousel;
                });

                console.log(this.files);
            });


            this.breadcrumb = this.intercalaire.name;

            if (this.category) {
                this.breadcrumb += ' -> ' + this.category.name;
            }

            if (this.subCategory) {
                this.breadcrumb += ' -> ' + this.subCategory.name;
            }

        }
    }

    playOral() {
        const audio = new Audio('data:audio/wav;base64,' + this.word.oral);
        audio.play();

        this.playing = true;
        setTimeout(() => {this.playing = false; }, 3000);
    }


    editWord() {
        this.wordEdit.emit(this.word);
    }

}
